import React from "react";
import { getFullName } from "../../components/util/helpers";
import { useIntl } from "react-intl";
import {
  IonContent,
  IonPage,
  IonTitle,
  IonToolbar,
  IonHeader,
  IonButtons,
  IonBackButton,
  useIonModal,
} from "@ionic/react";
import { useSelector } from "react-redux";
import FormWrapper from "./form/FormWrapper";
import PatientCard from "../patient/PatientCard";
import Logo from "../../components/Logo";

const NewVisit = (props) => {
  const intl = useIntl();
  const activeHouseVisit = useSelector((state) => state.visit.activeHouseVisit);

  const handleDismiss = () => {
    dismiss();
  };
  const [present, dismiss] = useIonModal(
    <PatientCard
      onHide={handleDismiss}
      patientId={activeHouseVisit.patient__id}
      branchId={activeHouseVisit.patient__branch}
    />,
    {
      onDismiss: handleDismiss,
    }
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonTitle>
            {intl.formatMessage({
              id: `app.mobile.new_visit`,
            })}
          </IonTitle>
          <IonButtons slot="end">
            <Logo />
          </IonButtons>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/app/patients"
              text={intl.formatMessage({
                id: `app.mobile.titles.patient_details`,
              })}
            />
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <FormWrapper present={present} type="new" />
      </IonContent>
    </IonPage>
  );
};

export default NewVisit;
